import axios from "../request";

//获取QQ群列表
export function getQQGroup(data) {
  return axios.request({
    url: "api/QqGroup",
    method: "get",
    params: data,
  });
}
//新增QQ群
export function addQQGroup(data) {
  return axios.request({
    url: "api/QqGroup",
    method: "post",
    data: data
  });
}

//删除QQ群
export function delQQGroup(id) {
  return axios.request({
    url: "api/QqGroup/"+id,
    method: "delete"
  });
}

//修改QQ群
export function updateQQGroup(id, data) {
  return axios.request({
    url: "api/QqGroup/"+id,
    method: "put",
    data: data
  });
}
